<!-- 个人中心-修改密码 -->
<template>
  <div class="personal-password-wp">
    <el-form class="ps-form" ref="form" :model="form" :rules="rules" label-width="8em" size="medium">
      <el-form-item label="原密码：" prop="oldPassword">
        <el-input v-model="form.oldPassword" class="w1" type="password" placeholder="请输入原密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input v-model="form.newPassword" class="w1" type="password" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码：" prop="confirm">
        <el-input v-model="form.confirm" class="w1" type="password" placeholder="请再次输入新密码"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="padding-left: 8em;">
          <el-button class="ps-btn" @click="resetForm()">取消</el-button>
          <el-button class="ps-btn com-ok-btn" @click="onSubmit()">确定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import {Encrypt} from '@/utils/AES-Encryption.js';

export default {
  name: 'personal-password',
  data () {
    const valConfrim = (rule, value, callback) => {
      if (this.form.newPassword != value) {
        callback(new Error('两次输入不一致'));
      } else {
        callback();
      }
    }

    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirm: '',
      },

      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度为6-20位', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: this.$val.reg.password, message: '由至少各一个的大小写字母数字组成，长度6-20位', trigger:"blur" },
        ],
        confirm: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: valConfrim, trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {

  },
  methods: {
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        var param = {
          oldPassword: Encrypt(this.form.oldPassword),
          newPassword: Encrypt(this.form.newPassword),
        }
        this.http.http('mem/user/changePassword', param).then(res => {
          res = res.data;
          if (res.resultCode == "SUCCESS") {
            this.util.logout({
              text: '密码修改成功，请登录'
            });
          }
        })
      })
    },

    // 重置表单
    resetForm () {
      this.$refs.form.resetFields();
    },

  }
}
</script>
<style lang="scss" scoped>
.personal-password-wp {
  padding-top: 40px;
}
</style>
<style lang="scss">
.personal-password-wp {
  .el-form-item__error {
    padding-left: 9em;
  }
}
</style>